<template lang="pug">
  .privilegeTreeSelector
    el-tree(:data="tree", show-checkbox, node-key="resource_id", :props="treeProps", ref="tree", @check-change="checkChange")
</template>

<script>
import getDataTree from '../gadgets/dataTree';

export default {
  props: {
    resource_ids: {
      type:     String,
      default:  null,
    },
    readOnly: {
      type:     Boolean,
      default:  false,
    },
  },
  data () {
    return {
      treeProps: {
        children: 'children',
        label:    'full_name'
      },
      tree:     [],
    };
  },
  computed: {
    privileges () {
      return this.$store.getters.privileges;
    },
  },
  methods: {
    createTree () {
      const privilegeArray = [];
      this.privileges.forEach((v) => {
        const node = Object.assign({}, v, {
          full_name:    `${v.title} [ ID：${v.resource_id}，${v.url} ]`,
        });
        privilegeArray.push(node);
      });
      const tree = getDataTree(privilegeArray);
      this.tree = tree;
      return tree;
    },
    setTree (keys) {
      this.$refs.tree.setCheckedKeys(keys);
    },

    resourceIdsFilter (keys) {
      let resource_ids = '';
      if (keys.length > 0) {
        let filtering = [];
        keys.forEach((k) => {
          filtering.push(parseInt(k));
        });
        resource_ids = filtering.join(',');
      }
      return resource_ids;
    },

    checkChange () {
      const resource_ids = this.resourceIdsFilter(this.$refs.tree.getCheckedKeys());
      if (resource_ids !== this.resource_ids) {
        this.$emit('change', resource_ids);
        this.$emit('update:resource_ids', resource_ids);
      }
    },
  },
  watch: {
    resource_ids (nv, ov) {
      if (nv !== ov) {
        let keys = [];
        if (nv) {
          keys = nv.split(',');
        }
        this.setTree(keys);
      }
    },
    readOnly () {
      this.createTree();
    },
  },
  mounted () {
    this.createTree();
  },
  updated () {
    let keys = [];
    if (this.resource_ids) {
      keys = this.resource_ids.split(',');
    }
    this.setTree(keys);
  }
};
</script>